import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from 'antd';
import {
  Input as InputComponent,
  TaxId as TaxIdComponent,
  Dropdown as DropdownComponent,
  Textarea as TextareaComponent,
  Pair,
  FIELD_PROPS,
  validateDateField,
} from '../Field';
import { HEADING_CLASSES } from '../Wizard';

const BusinessDetails = props => {
  // Sola's boarding application needs fields BlueSnap's SDK never asked for. They are shown
  // only for a merchant configured for Sola, so the BlueSnap wizard is unchanged.
  const { isSola } = props;
  const Input = inputProps => <InputComponent {...props} {...inputProps} />;
  const TaxInput = taxInputProps => <TaxIdComponent {...props} {...taxInputProps} />;
  const Dropdown = dropdownProps => <DropdownComponent {...props} {...dropdownProps} />;
  const Textarea = textareaProps => <TextareaComponent {...props} {...textareaProps} />;

  return (
    <>
      <fieldset className="m-btm-15">
        <Input id="businessName" label="Business Name" placeholder="ex. Company Name" maxLength="50" />
        <Input id="businessLegalName" label="Legal Business Name" placeholder="ex. Company Name, LLC" maxLength="60" />
        <Textarea
          id="businessProductAndServiceDesc"
          label="Please provide a detailed description of your product or service:"
          maxLength="1500"
        />
        <Input {...FIELD_PROPS.PHONE} id="businessPhone" type="number" label="Business Phone" />
        <Input id="businessWebsite" label="Website" placeholder="www." maxLength="100" />
        <Dropdown
          id="businessType"
          label="Business type"
          options={[
            'Private Corporation',
            'Limited Liability',
            'Non-profit',
            'Partnership',
            'Public Corporation',
            'Sole Proprietorship',
          ]}
        />
        {/* <Input id="businessTaxId" label="Business tax ID" maxLength="9" paymentInputSubText="Must be a 9-digit number e.g. 123456789" /> */}
        <TaxInput
          placeholder="000000000"
          id="businessTaxId"
          label="Business tax ID"
          minLength="9"
          maxLength="9"
          inputMode="numeric"
          paymentInputSubText="Must be a 9-digit number e.g. 123456789 with no dashes"
        />
        <Input
          placeholder="Average Transaction Amount"
          id="businessAverageTransactionAmount"
          label="Average Transaction Amount"
          maxLength="10"
          type="number"
        />
        <Input
          placeholder="Highest Transaction Amount"
          id="businessHighestTransactionAmount"
          label="Highest Transaction Amount"
          maxLength="10"
          type="number"
        />
        {isSola && (
          <>
            {/* type="email" is the format-validation hook in Wizard (and a keyboard hint); the
                form is noValidate so the browser's own check does not get in the way. */}
            <Input
              id="businessEmail"
              label="Business Email"
              placeholder="name@business.com"
              maxLength="100"
              type="email"
            />
            {/* Never sent: not read by getBusinessDetails, and no `forget` since it holds nothing
                secret. Compared against businessEmail in Wizard's validateFields. */}
            <Input
              id="businessEmailConfirm"
              label="Confirm Business Email"
              placeholder="name@business.com"
              maxLength="100"
              type="email"
            />
            <Input
              placeholder="Monthly Sales Volume"
              id="businessMonthlySalesVolume"
              label="Monthly Sales Volume"
              maxLength="12"
              type="number"
            />
            <Input
              {...FIELD_PROPS.DATE}
              id="businessStartDate"
              label="Business Start Date"
              paymentInputSubText="MM/DD/YYYY"
              onFieldValidate={validateDateField}
            />
          </>
        )}
      </fieldset>

      <fieldset>
        <legend className={HEADING_CLASSES}>Business Address</legend>
        <Input id="businessAddress" placeholder="Address" maxLength="40" />
        <Pair>
          <Input id="businessCity" placeholder="City" maxLength="25" />
          <Input id="businessState" placeholder="State" minLength="2" maxLength="2" />
        </Pair>
        <Input id="businessZip" placeholder="Zip Code" minLength="5" maxLength="10" />
      </fieldset>
    </>
  );
};

export default BusinessDetails;
